import { defineStore } from "pinia";
import axios from "axios";
import { marked } from "marked"; // Use named import for marked
import OpenAI from "openai";
import { ChatDb, Convo } from "../db/dexieConfig";
import { GoogleGenerativeAI } from "@google/generative-ai";
const openai = new OpenAI({
  apiKey: "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",
  dangerouslyAllowBrowser: true,
});
const gapiKey = "AIzaSyBQaXA4dRi8QWERa4KwSR2ulcGseGzyyII";
const genAI = new GoogleGenerativeAI(gapiKey);

import {
  collection,
  doc,
  addDoc,
  query,
  orderBy,
  limit,
  getDocs,
  setDoc,
  updateDoc,
  getDoc,
  where,
  limitToLast,
} from "firebase/firestore"; // Import Firestore functions
export const useConvoStore = defineStore("convo", {
  state: () => ({
    messages: [],
    isTyping: false,
    threadID: null,
    convodocid: null,
    currentStatusMessage: "",
    Loading: false,
    WhatAmIViewing: "Area",
    checklist: {},
    neighborhoodsEnabled: "False",
    rollingStatus: "",
    fullwidth: false,
    checklist_titles: [
      "Reviewing User Persona...",
      "Reviewing Moving Date...",
      "Creating Checklist...",
      "Reviewing the Checklist...",
      "Personalizing Checklist...",
    ],
    currentTitleIndex: 0,
  }),
  actions: {
    resetStore() {
      this.$reset(); // This resets the state to the initial state defined above
    },
    setTyping(status) {
      this.isTyping = status;
    },
    async createThread(personaid) {
      // Create a new thread
      console.log("creating thread");
      let thread = await openai.beta.threads.create();
      this.threadID = thread.id;
      const db = useFirestore()
      const threadDocRef = doc(collection(db, "Convo"));
      await setDoc(threadDocRef, {
        threadID: this.threadID,
        PersonaID: personaid,
      });
      console.log("created thread", thread);
      localStorage.setItem("thread", JSON.stringify(thread));
    },
    async getThread() {
      // Create a new thread
      let thread = JSON.parse(localStorage.getItem("thread")) || "";
      this.threadID = thread ? thread.id : "";
      return this.threadID;
    },
    async saveMessagetoChatDB(message, thread, mymessage, personid) {
      // Save user's message to ChatDb
      await ChatDb.chat.add({
        message_id: message.id,
        thread_id: thread,
        created_at: message.created_at,
        user: true,
        text: mymessage,
        personaid: personid,
      });
    },
    async savetoConvoDB(serializedChecklist, run, convodocid, personid) {
      // Save message to ChatDb
      await Convo.convodb.add({
        checklist: serializedChecklist,
        threadid: this.threadID,
        assistantid: run.assistant_id,
        personaid: personid,
        convodocid: "12312234513",
      });
    },
    async chatwithAgents(
      mymessage,
      personid,
      persona = "",
      form = {},
      specificTrigger = "None"
    ) {
      await this.getThread();
      let thread = this.threadID;
      let run;
      if (thread) {
        // Existing thread: Send message and create a run
        console.log("Continuing existing thread:", thread);

        // Send user's message
        const message = await openai.beta.threads.messages.create(thread, {
          role: "user",
          content: mymessage,
        });

        this.saveMessagetoChatDB(message, thread, mymessage, personid);

        // Create and poll a new run
        run = await openai.beta.threads.runs.createAndPoll(thread, {
          assistant_id: "asst_lCoem8OSf1ACjVpzK40XkqoG",
        });
      } else {
        // New thread: Initialize conversation
        console.log("Starting a new thread needing");
        await this.createThread(personid);
        // Send persona information (hidden from assistant)
        let message = await openai.beta.threads.messages.create(this.threadID, {
          role: "user",
          content: "<persona>" + persona + "<persona>",
        });
        message = await openai.beta.threads.messages.create(this.threadID, {
          role: "user",
          content: "<formData>" + form + "<formData>",
        });
        if ((specificTrigger = "Checklist")) {
          message = await openai.beta.threads.messages.create(this.threadID, {
            role: "user",
            content: `<pageNav>Be Aware the User has Navigated to the Checklist Page<PageNav>`,
          });
          message = await openai.beta.threads.messages.create(this.threadID, {
            role: "user",
            content: `Hello, Can you please create me a detailed moving checklist?`,
          });
        } else if ((specificTrigger = "Area")) {
          message = await openai.beta.threads.messages.create(this.threadID, {
            role: "user",
            content: `<pageNav>Be Aware the User has Navigated to the Neighbourhoods and City Page<PageNav>`,
          });
          message = await openai.beta.threads.messages.create(this.threadID, {
            role: "user",
            content: `Hello, Can you show me where I can live?`,
          });
        }
        console.log(message);
        // Create and poll a new run with additional instructions
        run = await openai.beta.threads.runs.createAndPoll(this.threadID, {
          assistant_id: "asst_lCoem8OSf1ACjVpzK40XkqoG",
        });
      }
      // Poll the run status until it's completed
      while (run.status !== "completed") {
        console.log(`Current run status: ${run.status}`);

        if (run.status === "requires_action") {
          // Handle required tool calls
          const toolCalls = run.required_action.submit_tool_outputs.tool_calls;
          this.isTyping = true;
          for (const toolCall of toolCalls) {
            if (toolCall.type === "function" && toolCall.function) {
              const toolName = toolCall.function.name;
              console.log(`Tool Name: ${toolName}`);

              if (toolName === "create_checklist") {
                // Handle 'create_checklist' tool call
                this.WhatAmIViewing = "Checklist";
                this.rollingStatus = this.checklist_titles[0];
                const toolCallId = toolCall.id;
                const argumentsStr = toolCall.function.arguments;
                const checklistData = JSON.parse(argumentsStr);
                console.log(checklistData);
                this.rollingStatus = this.checklist_titles[1];
                try {
                  this.rollingStatus = this.checklist_titles[2];
                  this.checklist = JSON.parse(
                    await this.createChecklist(checklistData, persona, personid)
                  );
                  const serializedChecklist = JSON.stringify(this.checklist);
                  this.savetoConvoDB(
                    serializedChecklist,
                    run,
                    "123456789",
                    personid
                  );

                  // Submit tool outputs and continue polling
                  run = await openai.beta.threads.runs.submitToolOutputsAndPoll(
                    this.threadID,
                    run.id,
                    {
                      tool_outputs: [
                        {
                          tool_call_id: toolCallId,
                          output:
                            "Checklist has been created and the user interface has been updated",
                        },
                      ],
                    }
                  );
                } catch (error) {
                  console.error("First attempt failed:", error);
                  try {
                    this.checklist = await this.createChecklist(
                      checklistData,
                      persona,
                      personid
                    );
                    const serializedChecklist = JSON.stringify(this.checklist);
                    this.savetoConvoDB(
                      serializedChecklist,
                      run,
                      "123456789",
                      personid
                    );
                    // Submit tool outputs and continue polling
                    run =
                      await openai.beta.threads.runs.submitToolOutputsAndPoll(
                        this.threadID,
                        run.id,
                        {
                          tool_outputs: [
                            {
                              tool_call_id: toolCallId,
                              output:
                                "Checklist has been created and the user interface has been updated" +
                                serializedChecklist,
                            },
                          ],
                        }
                      );
                  } catch (secondError) {
                    console.error("Second attempt failed:", secondError);
                    run =
                      await openai.beta.threads.runs.submitToolOutputsAndPoll(
                        this.threadID,
                        run.id,
                        {
                          tool_outputs: [
                            {
                              tool_call_id: toolCallId,
                              output:
                                "Failed to create checklist and submit tool outputs after two attempts.",
                            },
                          ],
                        }
                      );
                  }
                }
                console.log("Tool outputs submitted successfully.");
              } else if (toolName === "update_checklist") {
                // Handle 'create_checklist' tool call
                this.WhatAmIViewing = "Checklist";
                const toolCallId = toolCall.id;
                const argumentsStr = toolCall.function.arguments;
                const checklistData = JSON.parse(argumentsStr);
                console.log(checklistData);
                let AdditionalInstructions =
                  "Here is the current Checklist" +
                  JSON.stringify(this.checklist);
                try {
                  this.checklist = JSON.parse(
                    await this.createChecklist(
                      checklistData,
                      persona,
                      personid,
                      AdditionalInstructions
                    )
                  );
                  const serializedChecklist = JSON.stringify(this.checklist);
                  this.savetoConvoDB(
                    serializedChecklist,
                    run,
                    "123456789",
                    personid
                  );
                  // Submit tool outputs and continue polling
                  run = await openai.beta.threads.runs.submitToolOutputsAndPoll(
                    this.threadID,
                    run.id,
                    {
                      tool_outputs: [
                        {
                          tool_call_id: toolCallId,
                          output:
                            "Checklist has been created and the user interface has been updated",
                        },
                      ],
                    }
                  );
                } catch (error) {
                  console.error("First attempt failed:", error);
                  try {
                    this.checklist = await this.createChecklist(
                      checklistData,
                      persona,
                      personid
                    );
                    const serializedChecklist = JSON.stringify(this.checklist);
                    this.savetoConvoDB(
                      serializedChecklist,
                      run,
                      "123456789",
                      personid
                    );
                    // Submit tool outputs and continue polling
                    run =
                      await openai.beta.threads.runs.submitToolOutputsAndPoll(
                        this.threadID,
                        run.id,
                        {
                          tool_outputs: [
                            {
                              tool_call_id: toolCallId,
                              output:
                                "Checklist has been created and the user interface has been updated" +
                                serializedChecklist,
                            },
                          ],
                        }
                      );
                  } catch (secondError) {
                    console.error("Second attempt failed:", secondError);
                    run =
                      await openai.beta.threads.runs.submitToolOutputsAndPoll(
                        this.threadID,
                        run.id,
                        {
                          tool_outputs: [
                            {
                              tool_call_id: toolCallId,
                              output:
                                "Failed to create checklist and submit tool outputs after two attempts.",
                            },
                          ],
                        }
                      );
                  }
                }
                console.log("Tool outputs submitted successfully.");
              } else if (toolName === "trigger_neighborhood_search") {
                const toolCallId = toolCall.id;
                const argumentsStr = toolCall.function.arguments;
                const neighborhoods = JSON.parse(argumentsStr);
                print("Neigbourhoods");
                this.getTopNeighbourhoods(neighborhoods);
                await openai.beta.threads.runs.submitToolOutputsAndPoll(
                  this.threadID,
                  run.id,
                  {
                    tool_outputs: [
                      {
                        tool_call_id: toolCallId,
                        output:
                          "Neighbourhoods have been found and displayed on the right.",
                      },
                    ],
                  }
                );
              }
            }
            console.log("Tool outputs submitted successfully.");
          }
        }
      }

      // Wait before checking the run status again
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Refresh the run status
      run = await openai.beta.threads.runs.retrieve(this.threadID, run.id);

      // Retrieve and process messages after run completion
      this.getMessages(run.thread_id, personid);
    },
    async informAgent(notification, specificTrigger = None) {
      if ((specificTrigger = "Checklist")) {
        message = await openai.beta.threads.messages.create(this.threadID, {
          role: "user",
          content: `<pageNav>Be Aware the User has Navigated to the Checklist Page<PageNav>`,
        });
      } else if ((specificTrigger = "Area")) {
        message = await openai.beta.threads.messages.create(this.threadID, {
          role: "user",
          content: `<pageNav>Be Aware the User has Navigated to the Neighbourhoods and City Page<PageNav>`,
        });
      }
      run = await openai.beta.threads.runs.createAndPoll(this.threadID, {
        assistant_id: "asst_lCoem8OSf1ACjVpzK40XkqoG",
      });
    },
    async getMessages(thread_id, personid) {
      console.log("Fetching messages for thread:", thread_id, personid);

      // Fetch messages from OpenAI API
      const messages = await openai.beta.threads.messages.list(thread_id);

      // Process each message
      for (const message of messages.data.reverse()) {
        const messageId = message.id;
        const createdAt = message.created_at;
        const role = message.role;
        const content = message.content[0].text.value;

        // Skip persona messages
        if (!content.includes("<persona>")) {
          // Check if the message already exists in ChatDb
          const messageExists = await ChatDb.chat
            .where({ message_id: messageId, thread_id })
            .count();

          if (messageExists === 0) {
            // Save new message to ChatDb

            await ChatDb.chat.add({
              message_id: messageId,
              thread_id,
              created_at: createdAt,
              user: role === "user",
              text: content,
              personaid: personid, // Ensure personaId is defined
            });
          }
        }
      }

      // Retrieve messages from ChatDb for display
      const dbMessages = await ChatDb.chat
        .where("thread_id")
        .equals(thread_id)
        .sortBy("created_at");

      // Update local messages array
      this.messages = dbMessages.map((message) => ({
        user: message.user,
        text: message.text,
        htmlContent: message.text,
      }));

      //this.setTyping(false);
    },

    async getTopNeighbourhoods(criteria) {
      console.log(criteria);
      this.neighborhoodsEnabled = "True";
    },
  },
  getters: {
    lastUserMessage(state) {
      return state.messages
        .slice()
        .reverse()
        .find((message) => message.user);
    },
    lastBotMessage(state) {
      return state.messages
        .slice()
        .reverse()
        .find((message) => !message.user);
    },
  },
});
